/**
 * Name und Lesen des Cookies, in das `ui/sidebar.tsx` den Zustand der Leiste
 * schreibt. Bis WP6 wurde das Cookie geschrieben, aber nie gelesen: Layout
 * setzte `defaultOpen={false}` fest, nach jedem Reload war die Leiste zu und
 * Kontingent und Systemstatus damit unsichtbar (A3-11).
 */
export const SIDEBAR_STATE_COOKIE = 'sidebar:state';

export function readSidebarDefaultOpen(cookieString: string): boolean {
  for (const part of cookieString.split(';')) {
    const [rawName, ...rest] = part.trim().split('=');
    if (rawName === SIDEBAR_STATE_COOKIE) return rest.join('=') === 'true';
  }
  return false;
}
